import React from 'react';
import { Multiselect } from 'fw/forms';
import * as API from 'modules/app/API'

class ChannelMultiselect extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { ...this.initialState(), loading: true }
    }

    initialState = () => {
        API.Biz.get('/retail/customers/query/getChannels', {},
            {
                success: (r) => {
                    this.setState({
                        loading: false,
                        items: r.data.items.map((item) => { return { label: item.channelName, value: item.channelId } })
                    });
                }
            });
    }

    render() {
        if (this.state.loading)
            return null;

        return (
            <Multiselect
                {...this.props}
                items={this.state.items} />)
    }
}

export default ChannelMultiselect;

// Mark this as a form component
ChannelMultiselect.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/channelMultiselect/ChannelMultiselect.js